(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
document.querySelector('.cart-items__empty-button,.continue-button')?.addEventListener('click', function (e) {
  e.preventDefault();
  e.stopPropagation();

  document.querySelector('.cart-drawer__close-button')?.click();

  return false;
});

});
  } catch(e) { console.error(e); }
})();

})();
